import React , {useState} from 'react';
import {useHistory} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import setPropertyVh from '../../utils/setPropertyVh';
import Xbutton from "components/Xbutton";
import StepRequirement from 'components/StepRequirement/StepRequirement';
import VideoPlayer from 'components/VideoPlayer/VideoPlayer';
import './LessonLobby.scss'

import FadeToBlackTransition from 'components/Transitions/FadeToBlackTransition';
import LessonOnboarding from './LessonOnboarding';
import usePDFdetails from 'utils/hooks/getPDFdetails';


const LessonLobby = ({
            pathName,
            teaserThumbnail,
            lessonImgURL,
            name,
            description,
            instructorName,
            AnimalType,
            teaserUrl,
            stepRequirements,
            onContinue,
            VolumeSwitchState,
            LessonStarted,
            onIntroCompleted,
            onXbutton: onXbuttonProp,
            isLocked,
            onSubscribe,
    }) => {
    const history = useHistory();

    const {t} = useTranslation();
    const { pdfUrl, thumbSrc } = usePDFdetails(pathName);
    setPropertyVh();

    const onExit = () => {
        setVideoPlayer(false)
    }

    const onXbutton = onXbuttonProp || (() => history.push('/theatre'));

    const handleOnPrint = () => {
        window.open(pdfUrl, '_blank')
    }
    
    const [fadeToVideo, setFadeToVideo] = useState(false)
    const handleOnContinue = () => {
        LessonStarted ? onContinue() : setFadeToVideo(true)
    }
    
    const runOnContinue = () => {
        onContinue()
    }


    const onOpenVideo = () => {
            setVideoPlayer(true)
    }


    const [videoPlayer, setVideoPlayer] = useState(false)
    return (
        // <>
        // <FadeToBlackTransition 
        //     shouldStart={fadeToVideo}
        //     setShouldStart={setFadeToVideo}
        //     functionToFire={()=>setVideoPlayer(true)}
        //     duration={1400}
        // />
        // {videoPlayer && 
        //     <div className="lessonLobby-container--video">
        //         <VideoPlayer
        //             URL={teaserUrl}
        //             onExit={onExit}
        //             onContinue={LessonStarted ? onExit : onContinue}
        //             IsCurrentSelectedStepItemCompleted={true}
        //             volume={VolumeSwitchState}
        //             VideoPlayerLoop={false}
        //         />
        //   </div>
        //   }     
        //   {!videoPlayer &&  
          <>              
        
        {!LessonStarted && <LessonOnboarding
            stepRequirements={stepRequirements}
            lessonPathname={pathName}
            onFinish={runOnContinue}
            onExit={onXbutton}
            exitButtonType="exit"
            lessonImgURL={lessonImgURL}
            name={name}
            description={description}
            instructorName={instructorName}
            AnimalType={AnimalType}
            teaserUrl={teaserUrl}
            teaserThumbnail={teaserThumbnail}
            VolumeSwitchState={VolumeSwitchState}
            onIntroCompleted={onIntroCompleted}
            isLocked={isLocked}
            onSubscribe={onSubscribe}
            />}
        {LessonStarted &&
        <>
            <div className={"Onboarding-container"}>
                <div className={"Onboarding-header"}>
                    <div className={"Onboarding-header__side"} />
                    <div className={"Onboarding-header__center"}>{name}</div>
                    <div className={"Onboarding-header__side Onboarding-header__side--end"}>
                        {/* <Xbutton sizeM onClose={onXbutton} /> */}
                    </div>
                </div>
                <div className={"Onboarding-content hideScrollbar noselect"}>
                        <div className={"Onboarding-title"}>{t("general.prepForLesson")}</div>
                        <div className="content-ab max-width-900">

                            {stepRequirements.map((Requirement, index) => {
                                    return (
                                        <div className="req-container " key={index}>
                                            <StepRequirement
                                                key={index}
                                                type={Requirement.name}
                                                showDescription
                                                imgPath={thumbSrc}
                                                RadioButton={!LessonStarted}
                                                hideName={Requirement.name === "activityPage"}
                                                onClick={Requirement.name === "activityPage" ? handleOnPrint : undefined}
                                                sizeM
                                                whiteText
                                                />
                                            {Requirement.name === "activityPage" && 
                                                <button onClick={handleOnPrint} className={"buttonCatbears buttonCatbears_CTA req-container_miniButton"}>
                                                    <img src="/assets/icons/icon-print.svg" />
                                                    {t("general.printActivityPages")}
                                                </button> 
                                            }
                                        </div>
                                    )
                                })}
                        </div>
                </div>
                <div className={"Onboarding-footer"}>
                    <button onClick={handleOnPrint} className={" buttonCatbears "}>
                        <img src="/assets/icons/icon-print-w.svg" />
                        {t("general.printActivityPages")}
                    </button>          
                    <button onClick={handleOnContinue} className={" buttonCatbears buttonCatbears_CTA arcadeBtn"}>
                        {LessonStarted ? " ": <img src="/assets/icons/icon_play-circle-white.svg" />}
                        {LessonStarted ? t("general.backToLesson"): t("general.startLesson")}
                    </button>
                </div>
            </div>
        </>
        }
     </>
    )

}

export default LessonLobby